/**** cat.DevMnt */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'cat',
  table: 'DevMNT',
  title: 'МНТ',
  elemsOnPage: 100,
  apiType: apiTypes.DEFAULT,
  connections: {
    vehicle: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'Vehicle',
      index: 'vehicle_id',
      fields: ['depot_number'],
      format: (elem: any) => elem['depot_number'],
      autocomplete: true,
    },
    mnttype: {
      apiType: apiTypes.DEFAULT,
      schema: 'cat',
      table: 'DevMNTType',
      index: 'id',
      fields: ['name'],
      format: (elem: any) => elem['name'],
      autocomplete: true
    },
  },
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'ip',
      title: 'IP-адрес',
      type: 'text',
      required: true,
      validate: (value: any) =>
        /\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/.test(value),
      validateError: 'Неверный формат IP-адреса',
    },
    {
      name: 'DevMNTType_id',
      title: 'Тип МНТ',
      type: 'number',
      required: true,
      connection: 'mnttype',
    },
    {
      name: 'vehicle_id',
      title: 'Транспортное средство',
      type: 'number',
      required: true,
      connection: 'vehicle'
    },
    {
      name: 'peer_address',
      title: 'Адрес участника соединения',
      type: 'number',
      required: true,
    },
    {
      name: 'serial_number',
      title: 'Серийный номер',
      type: 'text',
      required: false,
    },
    {
      name: 'login',
      title: 'Логин',
      type: 'text',
      required: false,
    },
    {
      name: 'password',
      title: 'Пароль',
      type: 'text',
      required: false,
    },
    {
      name: 'port',
      title: 'Порт',
      type: 'number',
      required: false,
    },
    {
      name: 'msip',
      title: 'IP-адрес медиа-сервера',
      type: 'text',
      required: false,
      validate: (msValue: any) =>
        /\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/.test(msValue),
      validateError: 'Неверный формат IP-адреса',
    },
    {
      name: 'msport',
      title: 'Порт медиа-сервера',
      type: 'number',
      required: false,
    },
    {
      name: 'mslogin',
      title: 'Логин медиа-сервера',
      type: 'text',
      required: false,
    },
    {
      name: 'mspassword',
      title: 'Пароль медиа-сервера',
      type: 'text',
      required: false,
    },
    {
      name: 'msuse',
      title: 'Работа с медиа-сервером',
      type: 'boolean',
      required: false,
      disabled: false,
      conditions: [
        {
          condition: 'auto-set',
          value: 'inherited',
          viceVersaValue: 'meta-disable',
          priority: 1,                        // lower = higher priority
          dependens: [
            {
              name: 'msip',
              condition: 'is-not-empty'
            },
            {
              name: 'msport',
              condition: 'is-not-empty'
            },
            {
              name: 'mslogin',
              condition: 'is-not-empty'
            },
            {
              name: 'mspassword',
              condition: 'is-not-empty'
            }
          ]
        }
      ]
    },
  ],
  newTemplate: {
    id: null,
    ip: '',
    DevMNTType_id: null,
    vehicle_id: null,
    peer_address: null,
    login: '',
    password: '',
    port: null,
    msip: '',
    mslogin: '',
    mspassword: '',
    msport: null,
    msuse: false,
  },
  createField: 'createdAt',
  updateField: 'updatedAt',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'equipment_id',
        field: 'id',
      },
      {
        title: 'ip',
        field: 'ip',
      },
      {
        title: 'model_id',
        field: 'DevMNTType_id',
      },
      {
        title: 'peer_address',
        field: 'peer_address',
      },
      {
        title: 'login',
        field: 'login',
      },
      {
        title: 'password',
        field: 'password',
      },
      {
        title: 'port',
        field: 'port',
      },
      {
        title: 'vehicle_id',
        field: 'vehicle_id',
      },
      {
        title: 'msip',
        field: 'msip',
      },
      {
        title: 'mslogin',
        field: 'mslogin',
      },
      {
        title: 'mspassword',
        field: 'mspassword',
      },
      {
        title: 'msport',
        field: 'msport',
      },
      {
        title: 'msuse',
        field: 'msuse',
      }
    ],
    example: `1;127.0.0.1;00-14-22-01-23-45;1;admin;password;8080;1;127.0.0.1;user;password;8080;false`,
  },
  export: {
    fields: [
      {
        name:  'ip',
        title: 'IP-адрес',
      },
      {
        name:               'DevMNTType_id',
        title:              'Тип МНТ',
        connectionGetField: 'name',
      },
      {
        name:               'vehicle_id',
        title:              'Транспортное средство',
        connectionGetField: 'depot_number',
      },
      {
        name:  'peer_address',
        title: 'Адрес участника соединения',
      },
      {
        name:  'serial_number',
        title: 'Серийный номер',
      },
      {
        name:  'login',
        title: 'Логин',
      },
      {
        name:  'password',
        title: 'Пароль',
      },
      {
        name:  'port',
        title: 'Порт',
      },
      {
        name:  'msip',
        title: 'IP-адрес медиа-сервера',
      },
      {
        name:  'msport',
        title: 'Порт медиа-сервера',
      },
      {
        name:  'mslogin',
        title: 'Логин медиа-сервера',
      },
      {
        name:  'mspassword',
        title: 'Пароль медиа-сервера',
      },
      {
        name:  'msuse',
        title: 'Работа с медиа-сервером',
        defaultValue: 'нет',
        format: {
          fields: ['msuse'],
          template: '%1',
          values: {
            'true': 'да',
            'false': 'нет',
          },
        },
      },
    ],
  }
};

export default config;
